@if (depId !== ALL_DEPS_TOKEN) {
  <div
    [class.main-menu-tree-container]="!shouldUseInfiniteScroll"
    [class.menu-tree-top-padding-for-infinite-scroll]="shouldUseInfiniteScroll"
    [ngClass]="{ 'editable-container-styles': showFunctionalButtons }"
    *appLoader="
      (showFunctionalButtons && (loaded$ | async) === false) ||
      (actions | actionInProgress | async) === true
    "
  >
    <div [class.menu-tree-buttons-container]="!shouldUseInfiniteScroll">
      @if (isRootAddEnabled) {
        <app-menu-tree-buttons
          [moduleNumber]="moduleNumber"
          [onlyAdd]="true"
          [tenantId]="tenantId"
          [adminPrivilege]="adminPrivilege"
        ></app-menu-tree-buttons>
      }
    </div>
    @if (structurePreview.length > 0) {
      @if (shouldUseInfiniteScroll) {
        <div
          #scrollContainer
          class="menu-tree-scroll-container"
          [style.max-height.px]="scrollContainerMaxHeightPx ?? undefined"
          [class.menu-tree-scroll-overflow]="contentExceedsContainer"
        >
          @for (
            item of visibleStructurePreview;
            track item.id;
            let i = $index;
            let f = $first;
            let l = $last
          ) {
            <app-menu-tree-single
              [item]="item"
              [module]="module"
              [moduleNumber]="moduleNumber"
              [tenantId]="tenantId"
              [showFunctionalButtons]="showFunctionalButtons"
              [menuItemsAsRouting]="menuItemsAsRouting"
              [menuMode]="menuMode"
              [mainModules]="true"
              [isTopItem]="f"
              [isLast]="l"
              [nextItem]="visibleStructurePreview[i + 1]"
              [chosenElementId]="chosenElementId"
              [adminPrivilege]="adminPrivilege"
              (chosenElementClicked)="highlightMenuItem($event)"
            ></app-menu-tree-single>
          }
        </div>
      } @else {
        @for (
          item of structurePreview;
          track item.id;
          let i = $index;
          let f = $first;
          let l = $last
        ) {
          <app-menu-tree-single
            [item]="item"
            [module]="module"
            [moduleNumber]="moduleNumber"
            [tenantId]="tenantId"
            [showFunctionalButtons]="showFunctionalButtons"
            [menuItemsAsRouting]="menuItemsAsRouting"
            [menuMode]="menuMode"
            [mainModules]="true"
            [isTopItem]="f"
            [isLast]="l"
            [nextItem]="structurePreview[i + 1]"
            [chosenElementId]="chosenElementId"
            [adminPrivilege]="adminPrivilege"
            (chosenElementClicked)="highlightMenuItem($event)"
          ></app-menu-tree-single>
        }
      }
    }
  </div>
}
